<template>
  <div class="stoppanel-container">
    <transition-group name="list" tag="div">
      <div v-for="(stopObj, index) in stateData.workingStops.value" :key="stopObj.reference" class="stop-card">
        <div class="stop-card-header">
          <span class="db-badge">{{ stopObj.dbname }}</span>
          <div class="controls">
            <button @click="stateData.MoveStopUp(index)" :disabled="index === 0" class="control-btn" title="Move Up">▲</button>
            <button @click="stateData.MoveStopDown(index)" :disabled="index === stateData.workingStops.value.length - 1" class="control-btn" title="Move Down">▼</button>
            <button @click="stateData.RemoveStop(index)" class="control-btn remove" title="Remove">✕</button>
          </div>
        </div>
        <div class="stop-card-content">
          <StopPanelEntry :stopObj="stopObj" />
        </div>
      </div>
    </transition-group>
    <div v-if="stateData.workingStops.value.length === 0" class="empty-state">
      <p>No stops added yet. Search and add stops to begin tracking.</p>
    </div>
  </div>
</template>

<script setup>
import { inject } from 'vue';
import StopPanelEntry from '../components/StopPanelEntry.vue';

const stateData = inject('stateData');

</script>

<style scoped>
.stoppanel-container {
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;
  max-height: 100%;
}

.stop-card {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  color: #e0e0e0;
}

.stop-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
  border-color: rgba(255, 255, 255, 0.2);
}

.stop-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 8px;
}

.db-badge {
  background: linear-gradient(135deg, #367530, #2d5a27);
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.controls {
  display: flex;
  gap: 4px;
}

.control-btn {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: #ccc;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  transition: all 0.2s ease;
}

.control-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.control-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.control-btn.remove:hover {
  background: #ff4d4d;
  color: white;
}

.stop-card-content {
  font-size: 0.9rem;
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #888;
  font-style: italic;
  border: 2px dashed rgba(255, 255, 255, 0.1);
  border-radius: 12px;
}

/* List animations */
.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}
.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}
.list-move {
  transition: transform 0.5s ease;
}
</style>